import axiosInstance from "./authentication/axiosInstance";

export const leaveServices = {

  applyLeave: async (payload) => {
    const response = await axiosInstance.post("/leave/apply", payload);
    return response.data;
  },

  editLeaveRequest: async (payload) => {
    const response = await axiosInstance.put("/leave/edit", payload);
    return response.data;
  },

  cancelLeaveRequest: async (leaveId, userId) => {
    const response = await axiosInstance.put(`/leave/cancel/${leaveId}?userId=${userId}`);
    return response.data;
  },

  requestLeaveCancellation: async (leaveId, userId, cancellationReason) => {
    const response = await axiosInstance.put("/leave/requestCancellation", {
      id: leaveId,
      userId,
      cancellationReason: cancellationReason || null
    });
    return response.data;
  },

  getAllLeaves: async (userId, roles, status, startDate, endDate, page = 0, size = 10, search = '', sortField = 'createdAt', sortDir = 'desc') => {
    const params = new URLSearchParams({
      userId,
      roles: Array.isArray(roles) ? roles.join(',') : roles,
      status,
      startDate,
      endDate,
      pageNo: page,
      size,
      sortField,
      sortDir,
    });
    if (search) params.set('search', search);
    const response = await axiosInstance.get(`/leave/getAllLeaves?${params.toString()}`);
    return response.data;
  },

  updateLeaveStatus: async (leaveId, status, actionById, actionByName, actionByComment) => {
    const response = await axiosInstance.put("/leave/updateStatus", {
      id: leaveId,
      status,
      actionById,
      actionByName,
      actionByComment: actionByComment || null
    });
    return response.data;
  },

  getLeavesByUserId: async (userId, status, startDate, endDate, page = 0, size = 10, search = '', sortField = 'createdAt', sortDir = 'desc') => {
    const params = new URLSearchParams({
      status,
      startDate,
      endDate,
      pageNo: page,
      size,
      sortField,
      sortDir,
    });
    if (search) params.set('search', search);
    const response = await axiosInstance.get(`/leave/leavesByUserId/${userId}?${params.toString()}`);
    return response.data;
  },

};
